"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var tslib_1 = require("tslib");
/* eslint-disable dot-notation */
var react_1 = (0, tslib_1.__importStar)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var controlled_1 = require("../form/controlled");
var forward_ref_with_statics_1 = require("../_util/forward-ref-with-statics");
var config_context_1 = require("../_util/config-context");
var noop_1 = require("../_util/noop");
var remove_emoji_1 = require("../_util/remove-emoji");
var TextArea_1 = require("./TextArea");
var InputPassword_1 = require("./InputPassword");
var button_1 = require("../button");
exports.Input = (0, forward_ref_with_statics_1.forwardRefWithStatics)(function (props, ref) {
    var _a;
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _b = (0, controlled_1.useDefaultValue)(props, ''), children = _b.children, // never
    multiline = _b.multiline, placeholder = _b.placeholder, disabled = _b.disabled, readonly = _b.readonly, size = _b.size, heightSize = _b.heightSize, type = _b.type, baseClassName = _b.baseClassName, className = _b.className, style = _b.style, value = _b.value, allowClear = _b.allowClear, allowEmoji = _b.allowEmoji, onChange = _b.onChange, showCount = _b.showCount, _c = _b.onCompositionStart, onCompositionStart = _c === void 0 ? noop_1.noop : _c, _d = _b.onCompositionEnd, onCompositionEnd = _d === void 0 ? noop_1.noop : _d, restProps = (0, tslib_1.__rest)(_b, ["children", "multiline", "placeholder", "disabled", "readonly", "size", "heightSize", "type", "baseClassName", "className", "style", "value", "allowClear", "allowEmoji", "onChange", "showCount", "onCompositionStart", "onCompositionEnd"]);
    var composingRef = (0, react_1.useRef)(false);
    // 记录 `composition` 事件过程中值以实现受控
    var _e = (0, tslib_1.__read)((0, react_1.useState)(''), 2), composingRefValue = _e[0], setComposingValue = _e[1];
    var basename = baseClassName || classPrefix + "-" + (multiline ? 'textarea' : 'input');
    var inputClassName = (0, classnames_1.default)((_a = {},
        _a[basename] = true,
        _a[className] = className,
        _a[classPrefix + "-input__allow-clear"] = allowClear && type !== 'password',
        _a["size-" + (size === 'full' ? size + "-width" : size)] = size,
        _a["height-size-" + heightSize] = heightSize,
        _a));
    var hasRows = multiline && restProps.rows;
    var inputProps = (0, tslib_1.__assign)({ placeholder: placeholder, className: inputClassName, readOnly: readonly, disabled: disabled, 
        // 受样式限制 rows 属性没有生效
        style: hasRows ? (0, tslib_1.__assign)({ height: 'auto' }, (style || {})) : style, value: composingRef.current ? composingRefValue : value, onChange: function (event) {
            var filteredValue = !allowEmoji ? (0, remove_emoji_1.removeEmoji)(event.target.value) : event.target.value;
            if (composingRef.current) {
                setComposingValue(filteredValue);
            }
            else {
                onChange(filteredValue, { event: event });
            }
        }, onCompositionStart: function (event) {
            composingRef.current = true;
            onCompositionStart(event);
        }, onCompositionEnd: function (event) {
            if (composingRef.current) {
                composingRef.current = false;
                onChange(event.currentTarget.value, { event: event });
            }
            setComposingValue('');
            onCompositionEnd(event);
        } }, restProps);
    if (multiline) {
        var component = react_1.default.createElement("textarea", (0, tslib_1.__assign)({ ref: ref }, inputProps));
        if (showCount) {
            var max = inputProps.maxLength;
            var len = value ? String(value).length : 0;
            return (react_1.default.createElement("div", { className: classPrefix + "-textarea-group" },
                component,
                react_1.default.createElement("label", { className: classPrefix + "-textarea__label" }, max ? len + " / " + max : len)));
        }
        return component;
    }
    return (react_1.default.createElement("span", { style: { position: 'relative' }, className: classPrefix + "-input__wrapper" },
        react_1.default.createElement("input", (0, tslib_1.__assign)({ ref: ref, type: type }, inputProps)),
        !readonly && !disabled && value && allowClear && type !== 'password' && (react_1.default.createElement("span", { className: classPrefix + "-input__op" },
            react_1.default.createElement(button_1.Button, { htmlType: "button", type: "icon", icon: "dismiss", onClick: function (event) {
                    return onChange("", { event: event });
                }, onMouseUp: function (e) { return e.preventDefault(); }, onMouseDown: function (e) { return e.preventDefault(); } })))));
}, {
    /**
     * TextArea 组件
     */
    TextArea: TextArea_1.TextArea,
    /**
     * Password 组件
     */
    Password: InputPassword_1.InputPassword,
    /**
     * 在表单布局中，和 label 的默认对齐方式
     */
    defaultLabelAlign: 'middle',
});
exports.Input.displayName = 'Input';
